import { notification } from "antd";
import axios from "axios";

export const getPlans = async (token: string) => {
  let response = null;
  try {
    response = await axios({
      method: "get",
      url: `https://staging.logabyss.com/site/plans`,
      headers: { Authorization: `Bearer ${token}` },
    });
  } catch (error) {
    notification.error({
      message: "Error",
      description: "Failed to fetch plans",
    });

    console.error(error);
  }

  return response?.data;
};

export const changePlan = async (token: string, id: string) => {
  let response = null;
  try {
    response = await axios({
      method: "post",
      url: `https://staging.logabyss.com/stripe/checkout`,
      headers: { Authorization: `Bearer ${token}` },
      data: { planId: id },
    });
  } catch (error) {
    notification.error({
      message: "Error",
      description: "Failed to fetch plans",
    });

    console.error(error);
  }

  return response?.data;
};
